import { apiClient, USE_MOCK } from "./apiClient";
import mockDb from "./mockDb";

export const EmployeeService = {
  listEmployees: async () => {
    if (USE_MOCK) return mockDb.getEmployees();
    const { data } = await apiClient.get("/employees");
    return data;
  },

  createEmployee: async (payload) => {
    if (USE_MOCK) return mockDb.createEmployee(payload);
    const { data } = await apiClient.post("/employees", payload);
    return data;
  },

  updateEmployee: async (id, payload) => {
    if (USE_MOCK) return mockDb.updateEmployee(id, payload);
    const { data } = await apiClient.put(`/employees/${id}`, payload);
    return data;
  },

  deleteEmployee: async (id) => {
    if (USE_MOCK) return mockDb.deleteEmployee(id);
    await apiClient.delete(`/employees/${id}`);
    return true;
  },

  setEmployeeBlocked: async (id, isBlocked) => {
    if (USE_MOCK) return mockDb.toggleEmployeeBlock(id, isBlocked);
    const { data } = await apiClient.patch(`/employees/${id}/block`, { isBlocked });
    return data;
  }
};
